import * as React from 'react';
import { AbstractReactFactory } from '@projectstorm/react-canvas-core';
import { DiagramEngine } from '@projectstorm/react-diagrams-core';
import { BotMessageNodeModel, UserIntentNodeModel, StartNodeModel, ActionNodeModel } from './';
import UserIntentWidget from '../../../ui/editor/widget/UserIntentWidget/UserIntentWidget';
import BotMessageWidget from '../../../ui/editor/widget/BotMessageWidget/BotMessageWidget';
import StartWidget from '../../../ui/editor/widget/startWidget/StartWidget';
import ActionWidget from '../../../ui/editor/widget/actionWidget/ActionWidget';
import NodeTypes from '../NodeTypes';

export class UserIntentNodeFactory extends AbstractReactFactory<UserIntentNodeModel, DiagramEngine> {
  constructor() {
    super(NodeTypes.userIntentNode);
  }

  generateModel(initialConfig:any) {
    return new UserIntentNodeModel();
  }

  generateReactWidget(event:any): JSX.Element {
    return <UserIntentWidget engine={this.engine as DiagramEngine} node={event.model} />;
  }
}

export class BotMessageFactory extends AbstractReactFactory<BotMessageNodeModel, DiagramEngine> {
  constructor() {
    super(NodeTypes.botMessageNode);
  }

  generateModel(initialConfig:any) {
    return new BotMessageNodeModel();
  }

  generateReactWidget(event:any): JSX.Element {
    return <BotMessageWidget engine={this.engine as DiagramEngine} node={event.model} />;
  }
} 

export class StartNodeFactory extends AbstractReactFactory<StartNodeModel, DiagramEngine> {
  constructor() {
    super(NodeTypes.startNode);
  }

  generateModel(initialConfig:any) {
    return new StartNodeModel();
  }

  generateReactWidget(event:any): JSX.Element {
    return <StartWidget engine={this.engine as DiagramEngine} node={event.model} />;
  }
} 

export class ActionNodeFactory extends AbstractReactFactory<StartNodeModel, DiagramEngine> {
  constructor() {
    super(NodeTypes.actionNode);
  }

  generateModel(initialConfig:any) {
    return new ActionNodeModel();
  }

  generateReactWidget(event:any): JSX.Element {
    return <ActionWidget engine={this.engine as DiagramEngine} node={event.model} />;
  }
} 
